module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-900"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户组名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.title),
      expression: "form.title",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        _vm.form.title = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "父级用户组",
      "prop": "pid"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pid),
      expression: "form.pid"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "父级用户组"
    },
    domProps: {
      "value": (_vm.form.pid)
    },
    on: {
      "input": function($event) {
        _vm.form.pid = $event
      }
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.remark),
      expression: "form.remark"
    }],
    staticClass: "w-200",
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "备注"
    },
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        _vm.form.remark = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限分配"
    }
  }, [_c('div', {
    staticClass: "bor-gray h-400 ovf-y-auto bor-ra-5 bg-wh"
  }, _vm._l((_vm.nodes), function(item) {
    return _c('div', [_c('div', {
      staticClass: "bor-b-ccc bg-gra p-l-10 p-r-10"
    }, [_c('el-checkbox', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      domProps: {
        "value": (item.check)
      },
      on: {
        "change": function($event) {
          _vm.selectProjectRule(item)
        },
        "input": function($event) {
          item.check = $event
        }
      }
    }, [_vm._v(_vm._s(item.else))])]), _vm._v(" "), _vm._l((item.child), function(childItem) {
      return _c('div', [_c('div', {
        staticClass: "p-l-20 bor-b-ccc"
      }, [_c('el-checkbox', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (childItem.check),
          expression: "childItem.check"
        }],
        domProps: {
          "value": (childItem.check)
        },
        on: {
          "change": function($event) {
            _vm.selectModuleRule(childItem, item, childItem.child)
          },
          "input": function($event) {
            childItem.check = $event
          }
        }
      }, [_vm._v(_vm._s(childItem.else))])]), _vm._v(" "), _c('div', {
        staticClass: "p-l-40 bor-b-ccc bg-gra"
      }, _vm._l((childItem.child), function(grandChildItem) {
        return _c('el-checkbox', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (grandChildItem.check),
            expression: "grandChildItem.check"
          }],
          domProps: {
            "value": (grandChildItem.check)
          },
          on: {
            "change": function($event) {
              _vm.selectActionRule(grandChildItem, childItem, item)
            },
            "input": function($event) {
              grandChildItem.check = $event
            }
          }
        }, [_vm._v(_vm._s(grandChildItem.else))])
      }))])
    })], true)
  }))]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.add('form')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a300fa52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/structures/groups/add.vue
// module id = 1967
// module chunks = 2